<template>
  <b-tabs>
    <b-tab title="Corporate Detail" active>
      <corporate-detail-tab />
    </b-tab>
    <b-tab title="Accounting">
      <accounting-tab />
    </b-tab>
  </b-tabs>
</template>

<script>
import CorporateDetailTab from './CorporateDetail';
import AccountingTab from './Accounting';

export default {
  components: {
    CorporateDetailTab,
    AccountingTab,
  }
}
</script>